module.exports = __webpack_public_path__ + "img/autosense-mobile.5e62e5e7.png";